import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { superUserGuard } from './core/guards/super-user/super-user.guard';

const authGuards = environment.bypassAuth ? [] : [AuthGuard];

export const routes: Routes = [
  {
    path: 'chat',
    loadComponent: () => import('./pages/main/main.component'),
    canActivate: authGuards,
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/chat/chat.module'),
        canActivate: authGuards
      }
    ]
  },
  {
    path: 'admin',
    loadComponent: () => import('./pages/main/main.component'),
    canActivate: [...authGuards, superUserGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/admin/admin.routes'),
        canActivate: [...authGuards, superUserGuard]
      }
    ]
  },
  {
    path: 'error/:error',
    loadComponent: () => import('./pages/error/error.component')
  }
];
